// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { DnaSyngoviaNodesType } from './dna-syngovia-node';

export enum DnaSyngoviaGroupNodeEType {
  SERVER = 'server',
  MODALITY = 'modality',
  DIGITAL_PRODUCT = 'digital_product',
  CLIENT = 'client',
  DICOM_PROXY = 'dicom_proxy',
}

export interface DnaSyngoviaGroupNode {
  type: DnaSyngoviaGroupNodeEType;
  description: string;
  warnings?: string[] | null;
  nodes: DnaSyngoviaNodesType;
}
